type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  const alignment = align === "center" ? "text-center items-center" : "text-left items-start";

  return (
    <div className={`flex flex-col ${alignment} max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.22em] text-primary-600 uppercase">
          <span className="w-6 h-px bg-primary-400" aria-hidden="true"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 text-balance">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{description}</p>
      )}
    </div>
  );
}